import api from '@/utils/api';
import { NotificationManager } from 'react-notifications';
import { FETCH_SCHEDULE_JOBS, FETCH_SCHEDULE_JOB } from './types';

const showScheduleJobError = (error) => {
    NotificationManager.error(error.response?.data?.msg || 'Không thể xử lý danh mục công việc.');
};

export const fetchScheduleJobs = (filters = {}) => dispatch => api
    .get('/schedule-jobs', { params: filters })
    .then(res => {
        dispatch({ type: FETCH_SCHEDULE_JOBS, payload: res.data.data });
        return res.data;
    })
    .catch(error => {
        showScheduleJobError(error);
        return Promise.reject(error);
    });

export const fetchScheduleJob = id => dispatch => api
    .get(`/schedule-jobs/${id}`)
    .then(res => {
        dispatch({ type: FETCH_SCHEDULE_JOB, payload: res.data.data });
        return res.data.data;
    })
    .catch(error => {
        showScheduleJobError(error);
        return Promise.reject(error);
    });

export const createScheduleJob = data => () => api
    .post('/schedule-jobs', data)
    .then(res => {
        NotificationManager.success(res.data.msg);
        return res.data.data;
    })
    .catch(error => {
        showScheduleJobError(error);
        return Promise.reject(error);
    });

export const updateScheduleJob = (id, data) => () => api
    .put(`/schedule-jobs/${id}`, data)
    .then(res => {
        NotificationManager.success(res.data.msg);
        return res.data.data;
    })
    .catch(error => {
        showScheduleJobError(error);
        return Promise.reject(error);
    });

export const removeScheduleJobs = ids => () => api
    .delete('/schedule-jobs', { data: { ids } })
    .then(res => {
        NotificationManager.success(res.data.msg);
        return res.data;
    })
    .catch(error => {
        showScheduleJobError(error);
        return Promise.reject(error);
    });
